import styled from 'styled-components';
import { Box } from '../../../../CommonComponents/OPL/Box/Box';

interface DependentsGridProps {
  isBeneficiary?: boolean;
}

export const DependentsGrid = styled(Box)<DependentsGridProps>(({ isBeneficiary }) => ({
  display: 'grid',
  gridTemplateColumns: isBeneficiary ? '1fr 1fr 40px' : '1fr 200px 200px auto 40px',
  gap: '24px 16px',
}));
